import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type Props = {
  id: string
  children: React.ReactNode
}

const Portal = ({ id, children }: Props) => {
  const [container, setContainer] = useState<HTMLElement>(null)

  useEffect(() => {
    if (id === '') return

    const existedContainer = document.getElementById(id)
    if (existedContainer) {
      setContainer(existedContainer)
      return
    }

    const newContainer = document.createElement('div')
    newContainer.setAttribute('id', id)
    document.body.appendChild(newContainer)

    setContainer(newContainer)
  }, [id])

  return container ? createPortal(children, container) : null
}

export default Portal
